/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Shamelessly copied from Marvin's `smoldash`
 * See: https://github.com/marvinhagemeister/smoldash
 */
export default function merge(...objs) {
    const a = objs[0];
    for (let i = 1; i < objs.length; i++) {
        const b = objs[i];
        for (const k in b) {
            if (a[k] !== null &&
                b[k] !== null &&
                typeof a[k] === 'object' &&
                typeof b[k] === 'object') {
                merge(a[k], b[k]);
            }
            else {
                a[k] = b[k];
            }
        }
    }
    return objs[0];
}
